import sortBy from "lodash/sortBy";
import { combineActions, handleActions } from "redux-actions";

export default handleActions(
  {
    [combineActions("SUBSCRIPTIONS_GET_FULFILLED", "SUBSCRIPTIONS_UPDATE_FULFILLED")](
      state,
      { payload: { assetDigestSubscriptions, dealDigestSubscriptions, portfolioDealSubscriptions } }
    ) {
      return {
        assetDigestSubscriptions: sortBy(assetDigestSubscriptions, (s) => s.asset.name),
        dealDigestSubscriptions: sortBy(dealDigestSubscriptions, (s) => s.portfolio.name),
        portfolioDealSubscriptions: sortBy(portfolioDealSubscriptions, (s) => s.portfolio.name),
      };
    },
  },
  {}
);
